// Don't use `rem` units for anything since existing CSS `font-size` affects all rem units
// https://github.com/am-systems/am-web-properties/blob/c1d44502a5babfe955a7f7462eba23658a73bbe3/public/thecreditreview/css/top-services/media-query.css#L22-L25.
// Existing `rem` units are migrated values from old styles to avoid breaking layouts.
export const getStyles = ({ companyIndex }) => ({
	serviceFlag: {
		wrapper: "tw-absolute tw-top-[9px] tw-left-[-5px] tw-flex",
		flag: `tw-w-[24px] tw-h-[24px] tw-bg-[#1d8ce0] tw-shadow-[1px_3px_3px_lightgrey] tw-flex tw-items-center tw-justify-center tw-rounded-[3px] xs2:tw-w-[28px] xs2:tw-h-[28px] xs2:tw-p-0 tw-border-[1px] tw-border-solid  tw-border-[#1d8ce0]`,
		number:
			"tw-text-white tw-text-[12px] tw-font-[AvenirNextLTPro-Demi] tw-m-0 tw-pt-[2px] xs2:tw-text-[14px] tw-leading-[1.4286]",
		text: "tw-relative tw-ml-[0.25rem] tw-h-[24px] tw-border-l-2 tw-text-white tw-py-[0.5rem] tw-pl-[0.75rem] tw-flex tw-items-center tw-justify-center tw-bg-[#1d8ce0] tw-text-[12px] tw-font-semibold tw-leading-[15px] tw-shadow-[1px_3px_3px_lightgrey] xs2:tw-h-[28px] xs2:tw-text-[13px] after:tw-relative after:tw-left-[6px] after:tw-w-[22px] after:tw-inset-0 after:[border-right:13px_solid_white] after:[border-top:12px_solid_#1e8ce0] after:[border-bottom:12px_solid_#1e8ce0] xs2:after:[border-right:15px_solid_white] xs2:after:[border-top:14px_solid_#1e8ce0] xs2:after:[border-bottom:14px_solid_#1e8ce0]",
	},
	companyLogo: {
		picture: "tw-contents",
		image: "tw-max-w-[70%] lg:tw-max-w-[160px]",
	},
	benefitsList: {
		wrapper: "",
		list: "tw-text-[14px] tw-leading-5 tw-list-none tw-m-0 tw-p-0",
		listItem: `tw-mt-0 tw-mb-2 tw-mx-0 tw-pl-7 tw-text-black tw-bg-[url(/public/react-images/common/iconTick.svg)] tw-bg-no-repeat tw-bg-[left_top_5px]`,
		expandButton:
			"tw-mb-0 tw-mt-[5px] tw-w-full tw-mx-auto tw-flex tw-cursor-pointer tw-items-center tw-border-0 tw-bg-transparent tw-p-0 tw-pl-[25px] tw-text-[13px] tw-text-[#48484b] md:tw-mt-[1.25rem]",
		expandButtonIcon: "tw-ml-[8px] tw-w-[9px]",
	},
	reviewLink: {
		wrapper: "tw-text-[#1d8ce0] tw-text-[14px] tw-font-semibold tw-mt-3",
		text: "",
	},
});
